module.exports = __webpack_public_path__ + "img/admin-logo.4b65bf18.png";